import React from 'react'
import MainLayout from '../layouts/MainLayout'
import { Breadcrumb, Button, Form, Input, message } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../redux/store';
import { createContactForm } from '../redux/actions/contactForm';
const breadcrumbItems = [
  {
    title: 'Anasayfa',
    href: '/',
  },
  {
    title: 'İletişim',
    href: '/iletisim',
  },
];
const Contact = () => {

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading, success } = useSelector((state: RootState) => state.contactForm);
  const onFinish = async (values: any) => {
    try {
      await dispatch(createContactForm(values));
      if (success) {
        form.resetFields();
      }
    } catch (error: any) {
      message.error(error.response?.data?.message || 'Bir hata oluştu');
    }
  };
  return (
    <MainLayout>
      <Helmet>
        <title>İletişim | Sakarya Lastik</title>
        <meta name="description" content="İletişim sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
        <meta property="og:title" content="İletişim | Sakarya Lastik" />
        <meta property="og:description" content="İletişim sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className='flex w-full bg-gray-50 p-3 border rounded-md'>
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className='container mx-auto'>
        <h1 className='text-2xl font-bold my-5'>İletişim</h1>
        <div className='flex w-full justify-center'>
          <div className="flex flex-wrap gap-8 p-6 bg-white rounded-lg shadow-md w-full">
            {/* Google Maps */}
            <div className="w-full h-[400px] rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.83540256885957!2d30.372360635135326!3d40.83540256885957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDUwJzA3LjUiTiAzMMKwMjInMjAuNSJF!5e0!3m2!1str!2str!4v1620000000000!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title='Sakarya Lastik Konumu'
              ></iframe>
            </div>

            <div className='flex w-full lg:flex-nowrap flex-wrap gap-10'>
              <div className="flex flex-col w-full gap-4">
                {/* Adres Bilgileri */}
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-green-100 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Adres</h3>
                    <p className="text-gray-600">Tekeler, Adapazarı Kaynarca Yolu No:390/1, 54100 Adapazarı/Sakarya</p>
                  </div>
                </div>

                {/* İletişim Numaraları */}
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-green-100 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">İletişim Numaralarımız</h3>
                    <p className="text-gray-600">
                      <a href="tel:+905438783435" className="hover:text-green-600 transition-colors">0(543) 878-3435</a>
                    </p>
                    <p className="text-gray-600">
                      <a href="tel:+905357455407" className="hover:text-green-600 transition-colors">0(535) 745-5407</a>
                    </p>
                  </div>
                </div>

                {/* Çalışma Saatleri */}
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-green-100 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">Çalışma Saatleri</h3>
                    <p className="text-gray-600">Pazartesi - Cumartesi: 08:00 - 22:00</p>
                    <p className="font-medium text-green-600">Yol Yardım: 7/24</p>
                  </div>
                </div>

                {/* E-posta */}
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-green-100 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">E-posta</h3>
                    <p className="text-gray-600">
                      <a href="mailto:info@sakaryalastik.com" className="hover:text-green-600 transition-colors">info@sakaryalastik.com</a>
                    </p>
                  </div>
                </div>
              </div>

              <div className='flex flex-col w-full gap-4 justify-center'>
                <h1 className='text-2xl font-bold'>İletişim Formu</h1>
                <Form
                  form={form}
                  name="contact"
                  onFinish={onFinish}
                  layout="vertical"
                  className="w-full max-w-lg"
                >
                  <Form.Item
                    name="name"
                    label="Adınız Soyadınız"
                    rules={[{ required: true, message: 'Lütfen adınızı ve soyadınızı giriniz' }]}
                  >
                    <Input placeholder="Adınız Soyadınız" />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="E-posta Adresiniz"
                    rules={[
                      { required: true, message: 'Lütfen e-posta adresinizi giriniz' },
                      { type: 'email', message: 'Geçerli bir e-posta adresi giriniz' }
                    ]}
                  >
                    <Input placeholder="ornek@email.com" />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    label="Telefon Numaranız"
                    rules={[{ required: true, message: 'Lütfen telefon numaranızı giriniz' }]}
                  >
                    <Input placeholder="05XX XXX XX XX" />
                  </Form.Item>

                  <Form.Item
                    name="message"
                    label="Mesajınız"
                    rules={[{ required: true, message: 'Lütfen mesajınızı giriniz' }]}
                  >
                    <Input.TextArea rows={4} placeholder="Mesajınızı buraya yazınız..." />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      className="w-full bg-green-600 hover:bg-green-700"
                    >
                      Gönder
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default Contact